import React from "react";
import sidebarStyles from "./sidebar.module.css";

const Sidebar = () => {
  return (
    <section className={sidebarStyles.section}>
      <ul className={sidebarStyles.list}>
        <li>
          <a
            href="mailto:es0528664603@gmail.com"
            className={sidebarStyles.link}
          >
            <svg
              className={sidebarStyles.transform}
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0,0,256,256"
            >
              <g fill="#869ba9" strokeWidth="1" strokeMiterlimit="10">
                <g transform="scale(8,8)">
                  <path d="M6,7.03125c-0.30859,0 -0.59766,0.05859 -0.875,0.14453l2.91406,1.85547h15.92187l2.91406,-1.85547c-0.27734,-0.08594 -0.56641,-0.14453 -0.875,-0.14453zM4.11328,7.71875c-0.67578,0.55078 -1.11328,1.37891 -1.11328,2.3125v13c0,1.65234 1.34766,3 3,3h20c1.65234,0 3,-1.34766 3,-3v-13c0,-0.93359 -0.4375,-1.76172 -1.11328,-2.3125l-11.88672,7.5625zM6,12.44531l10,6.36719l10,-6.36719v11.58594h-20z" />
                </g>
              </g>
            </svg>
          </a>{" "}
        </li>
        <li>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://github.com/ElenaSolov"
            className={sidebarStyles.link}
          >
            <svg
              className={sidebarStyles.transform}
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0,0,256,256"
            >
              <g
                fill="#869ba9"
                strokeWidth="1"
                transform="scale(8.53333,8.53333)"
              >
                <path d="M15,3c-6.627,0 -12,5.373 -12,12c0,5.623 3.872,10.328 9.092,11.63c-0.056,-0.162 -0.092,-0.35 -0.092,-0.583v-2.051c-0.487,0 -1.303,0 -1.508,0c-0.821,0 -1.551,-0.353 -1.905,-1.009c-0.393,-0.729 -0.461,-1.844 -1.435,-2.526c-0.289,-0.227 -0.069,-0.486 0.264,-0.451c0.615,0.174 1.125,0.596 1.605,1.222c0.478,0.627 0.703,0.769 1.596,0.769c0.433,0 1.081,-0.025 1.691,-0.121c0.328,-0.833 0.895,-1.6 1.588,-1.962c-3.996,-0.411 -5.903,-2.399 -5.903,-5.098c0,-1.162 0.495,-2.286 1.336,-3.233c-0.276,-0.94 -0.623,-2.857 0.106,-3.587c1.798,0 2.885,1.166 3.146,1.481c0.896,-0.307 1.88,-0.481 2.914,-0.481c1.036,0 2.024,0.174 2.922,0.483c0.258,-0.313 1.346,-1.483 3.148,-1.483c0.732,0.731 0.381,2.656 0.102,3.594c0.836,0.945 1.328,2.066 1.328,3.226c0,2.697 -1.904,4.684 -5.894,5.097c1.098,0.573 1.899,2.183 1.899,3.396v2.734c0,0.104 -0.023,0.179 -0.035,0.268c4.676,-1.639 8.035,-6.079 8.035,-11.315c0,-6.627 -5.373,-12 -12,-12z" />
              </g>
            </svg>
          </a>
        </li>
        <li>
          <a
            href="https://www.linkedin.com/in/elena-soloveva-71bb9825a/"
            target="_blank"
            rel="noopener noreferrer"
            className={sidebarStyles.link}
          >
            <svg
              className={sidebarStyles.transform}
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0,0,256,256"
            >
              <g fill="#869ba9" strokeWidth="1">
                <g transform="scale(5.12,5.12)">
                  <path d="M25,2c-12.682,0 -23,10.317 -23,23c0,12.683 10.318,23 23,23c12.682,0 23,-10.317 23,-23c0,-12.683 -10.318,-23 -23,-23zM18,35h-4v-15h4zM16,17c-1.105,0 -2,-0.895 -2,-2c0,-1.105 0.895,-2 2,-2c1.105,0 2,0.895 2,2c0,1.105 -0.895,2 -2,2zM37,35h-4v-5v-2.5c0,-1.925 -1.575,-3.5 -3.5,-3.5c-1.925,0 -3.5,1.575 -3.5,3.5v7.5h-4v-15h4v1.816c1.168,-1.122 2.752,-1.816 4.5,-1.816c3.59,0 6.5,2.91 6.5,6.5z" />
                </g>
              </g>
            </svg>
          </a>
        </li>
      </ul>
    </section>
  );
};
export default Sidebar;
